module.exports = __webpack_public_path__ + "img/ListInactive.20f4d854.png";